
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/converter/xd-to-figma",
      function () {
        return require("private-next-pages/converter/xd-to-figma.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/converter/xd-to-figma"])
      });
    }
  